import { render, staticRenderFns } from "./Houses.vue?vue&type=template&id=5b0a6b22&scoped=true&"
import script from "./Houses.vue?vue&type=script&lang=js&"
export * from "./Houses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a6b22",
  null
  
)

export default component.exports